<template>
	<div class="register_progress_callback_table">
		<p class="doc_main_p">
			例如：“[0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]”
			<br>
			1：表示该角度注册成功
			<br>
			0：表示该角度注册失败
		</p>
		<div style="width: 800px;">
			<template>
			    <el-table
				    :data="tableData"
				    :span-method="objectSpanMethod"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="RegModel"
					        width="200px">
				      	</el-table-column>
				      	 <!--<el-table-column
				        	prop="index"
				        	label="Index"
				        	width="200px">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			<div v-for="item in scope.row.index" class="table_msg_list">
					    				{{item}}
					    			</div>
					    		</div>
					    	</template>
				      	</el-table-column>-->
				      	<el-table-column
				        	prop="msg"
				        	label="RegRes">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			<div v-for="item in scope.row.msg" class="table_msg_list">
					    				{{item}}
					    			</div>
					    		</div>
					    	</template>
				      	</el-table-column> 
				      	<!--<el-table-column
				        	prop="index"
				        	label="Index"
				        	width="200px">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.index}}
					    		</div>
					    	</template>
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="Msg">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template>
				      	</el-table-column>-->
			    </el-table>
			</template>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				tableData:[
					{
						"code":"0 (快速注册)",
						"msg":[
								'数组元素下标:',
								'0-17：右转头角度是否注册成功',
								'18-35：左转头角度是否注册成功',
								'36：正脸角度是否注册成功',
							  ]
					},
					{
						"code":"1 (标准注册)",
						"msg":[
								'0-8：仰头角度是否注册成功',
								'9-17：右转头角度是否注册成功',
								'18-26：低头角度是否注册成功',
								'27-35：左转头角度是否注册成功',
								'36：正脸角度是否注册成功',
							  ]
					},
					{
						"code":"2 (精准注册)",
						"msg":[
								'0-3：仰头角度是否注册成功',
								'4-8：右上方抬头角度是否注册成功',
								'9-12：右转头角度是否注册成功',
								'13-17：右下方低头角度是否注册成功',
								'18-21：低头角度是否注册成功',
								'22-26：左下方低头角度是否注册成功',
								'27-30：左转头角度是否注册成功',
								'31-35：左上方抬头角度是否注册成功',
								'36：正脸角度是否注册成功',
							  ]
					},
				],
				// tableData2:[
				// 	{
				// 		"code":"0 (快速注册)",
				// 		"index":[
				// 				'0-17',
				// 				'18-35',
				// 				'36',
				// 			  ],
				// 		"msg":[
				// 				'右转头角度是否注册成功',
				// 				'左转头角度是否注册成功',
				// 				'正脸角度是否注册成功',
				// 			  ]
				// 	},
				// 	{
				// 		"code":"1 (标准注册)",
				// 		"index":[
				// 				'0-8',
				// 				'9-17',
				// 				'18-26',
				// 				'27-35',
				// 				'36',
				// 			  ],
				// 		"msg":[
				// 				'仰头角度是否注册成功',
				// 				'右转头角度是否注册成功',
				// 				'低头角度是否注册成功',
				// 				'左转头角度是否注册成功',
				// 				'正脸角度是否注册成功',
				// 			  ]
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":[
				// 				'0-3',
				// 				'4-8',
				// 				'13-17',
				// 				'18-21',
				// 				'22-26',
				// 				'27-30',
				// 				'31-35',
				// 				'36',
				// 			  ],
				// 		"msg":[
				// 				'仰头角度是否注册成功',
				// 				'右上方抬头角度是否注册成功',
				// 				'右转头角度是否注册成功',
				// 				'右下方低头角度是否注册成功',
				// 				'低头角度是否注册成功',
				// 				'左下方低头角度是否注册成功',
				// 				'左转头角度是否注册成功',
				// 				'左上方抬头角度是否注册成功',
				// 				'正脸角度是否注册成功',
				// 			  ]
				// 	},
				// ],
				// tableData3:[
				// 	{
				// 		"code":"0 (快速注册)",
				// 		"index":"0-17",
				// 		"msg":"右转头角度是否注册成功",
				// 		"rowspan":3,
				// 		"colspan":1,
				// 	},
				// 	{
				// 		"code":"0 (快速注册)",
				// 		"index":"18-35",
				// 		"msg":"左转头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"0 (快速注册)",
				// 		"index":"36",
				// 		"msg":"正脸角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"1 (标准注册)",
				// 		"index":"0-8",
				// 		"msg":"仰头角度是否注册成功",
				// 		"rowspan":5,
				// 		"colspan":1,
				// 	},
				// 	{
				// 		"code":"1 (标准注册)",
				// 		"index":"9-17",
				// 		"msg":"右转头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"1 (标准注册)",
				// 		"index":"18-26",
				// 		"msg":"低头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"1 (标准注册)",
				// 		"index":"27-35",
				// 		"msg":"左转头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"1 (标准注册)",
				// 		"index":"36",
				// 		"msg":"正脸角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"0-3",
				// 		"msg":"仰头角度是否注册成功",
				// 		"rowspan":9,
				// 		"colspan":1,
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"4-8",
				// 		"msg":"右上方抬头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"9-12",
				// 		"msg":"右转头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"13-17",
				// 		"msg":"右下方低头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"18-21",
				// 		"msg":"低头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"22-26",
				// 		"msg":"左下方低头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"27-30",
				// 		"msg":"左转头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"31-35",
				// 		"msg":"左上方抬头角度是否注册成功",
						
				// 	},
				// 	{
				// 		"code":"2 (精准注册)",
				// 		"index":"36",
				// 		"msg":"正脸角度是否注册成功",
						
				// 	},
				// ],
			}
		},
		methods:{
			objectSpanMethod({ row, column, rowIndex, columnIndex }){
				console.log(row, column, rowIndex, columnIndex)
				// if (columnIndex === 0) {
			    //     if (rowIndex % 2 === 0) {
			    //         return {
			    //           rowspan: 2,
			    //           colspan: 1
			    //         };
			    //     } else {
			    //         return {
			    //           rowspan: 0,
			    //           colspan: 0
			    //         };
			    //     }
			   
		        // }	
			}
		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.register_progress_callback_table{
		//margin:5px 0 30px 30px;
		margin:5px 0 30px 0;
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				//text-align: left;
				.table_msg_list{
					padding: 2px 0;
				}
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/registerResultTable.vue